import React, { useMemo, useState, useContext, createContext } from 'react';
import { ThemeProvider, Theme, CssBaseline } from '@mui/material';

import { LightTheme, LightEspelho, LightHomologacao } from './../themes';


interface IThemeContextData {
  toggleTheme(): void;
  theme: Theme;
}

export const useThemesContext = () => useContext(ThemeContext);

const ThemeContext = createContext<IThemeContextData>({} as IThemeContextData);

export const ThemesProvider: React.FC = ({ children }) => {
  const { ambiente } = { ambiente: 'dev' };

  const temaPorAmbiente = useMemo(() => {
    switch (ambiente) {
      case 'dev':
        return LightTheme;
      case 'esp':
        return LightEspelho;
      case 'hml':
        return LightHomologacao;

      default:
        return LightTheme;
    }
  }, [ambiente]);

  const [themeData] = useState<IThemeContextData>({
    toggleTheme: () => { },
    theme: temaPorAmbiente,
  });

  return (
    <ThemeContext.Provider value={themeData}>
      <CssBaseline />
      <ThemeProvider theme={themeData.theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
